import React from 'react';
import NavigationState from 'js/stores/NavigationState';
import AppUser from 'js/stores/AppUser';
import { observer, Provider } from "mobx-react";
import { Header as GuestNav } from "js/new/Components/PageSections";
import AuthNav from "js/components-v2/common/Header/AuthNav";

const Header = observer(() => {
  const navigation = NavigationState.create();

  return (
    <Provider navigation={navigation}>
      {AppUser.isLoggedIn
        ? <div className="pod-nav-container">
          <div className="pod-container">
            <AuthNav />
          </div>
        </div>
        : <div className={'tw-bg-white new-pod-ui'}>
          <GuestNav />
        </div>
      }
    </Provider>
  );
});

export default Header;
